export default {"src":"/_next/static/media/luggage-policy.a15c7114.svg","height":559,"width":891,"blurWidth":0,"blurHeight":0};